var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Rest } from "../../Rest";
export class TssApiLegacy extends Rest {
    constructor(baseUrl, tenantToken, ciamToken) {
        super(baseUrl);
        this.tenantToken = tenantToken;
        this.ciamToken = ciamToken;
        this.setCommonHeader("X-DES-AK-TENANT-TOKEN", this.tenantToken);
        this.ciamToken && this.setCommonHeader("X-DES-CONSUMER-IAM-TOKEN", this.ciamToken); // TSS auth header
        this.ciamToken && this.setCommonHeader("X-DES-USER-TOKEN", this.ciamToken); // EVO auth header
    }
    getEligibility(_a) {
        return __awaiter(this, arguments, void 0, function* ({ categoryId, userId }) {
            try {
                const { is_eligible } = yield this.request(`/is-eligible/${categoryId}/${userId}`);
                return is_eligible;
            }
            catch (e) {
                return false;
            }
        });
    }
}
//# sourceMappingURL=TssApiLegacy.js.map